import { createClient } from '@supabase/supabase-js';

// Configuration Supabase
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://gsdyxbavdauoczemgvhj.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdzZHl4YmF2ZGF1b2N6ZW1ndmhqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjMxNTA1OTEsImV4cCI6MjA3ODcyNjU5MX0.BJ1b5s64G1R5vefuj1z3WJAbrvK742uCMqCWUzpsfzI';

// Note: Les clés sont configurées ici pour faciliter le développement
// En production, utilisez les variables d'environnement

// Client Supabase pour le frontend
// L'authentification se fait directement avec Supabase Auth, sans Edge Function
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
  global: {
    headers: {
      'X-Client-Info': 'soebra-zenith-client',
    },
    // SOLUTION DÉFINITIVE : Intercepter et bloquer les appels à l'Edge Function auth
    // qui causent l'erreur "Réponse de connexion invalide"
    fetch: (url, options: RequestInit = {}) => {
      const urlString = typeof url === 'string' ? url : url.toString();
      
      // Bloquer UNIQUEMENT les appels POST à /functions/v1/auth
      // NE JAMAIS bloquer les appels à /auth/v1/ qui sont nécessaires pour Supabase Auth
      // NE JAMAIS bloquer les appels GET ou OPTIONS
      if (
        urlString.includes('/functions/v1/auth') && 
        !urlString.includes('/auth/v1/') &&
        options.method === 'POST'
      ) {
        // Retourner une réponse valide immédiatement pour éviter toute attente
        return Promise.resolve(new Response(
          JSON.stringify({ success: true }),
          {
            status: 200,
            statusText: 'OK',
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
              'Access-Control-Allow-Headers': 'authorization, x-client-info, apikey, content-type',
            }
          }
        ));
      }
      
      // Pour toutes les autres requêtes, utiliser fetch normal
      return fetch(url, options);
    },
  },
});

// NOTE: Edge Functions ne sont plus utilisées
// L'authentification se fait maintenant directement avec Supabase Auth
// Cette fonction est conservée pour référence mais n'est plus utilisée
// 
// Si vous avez besoin d'appeler une Edge Function à l'avenir, utilisez :
// const { data, error } = await supabase.functions.invoke('function-name', { body });

/**
 * @deprecated Cette fonction est dépréciée et ne doit plus être utilisée.
 * L'authentification se fait maintenant directement avec Supabase Auth.
 * Cette fonction est conservée uniquement pour éviter les erreurs de build.
 */
export const callEdgeFunction = async (functionName: string, body?: any) => {
  console.warn('callEdgeFunction est dépréciée. Utilisez supabase.functions.invoke() directement.');
  const { data, error } = await supabase.functions.invoke(functionName, { body });
  if (error) throw error;
  return data;
};

